<template>
    <!--    右上角的操作欄    -->
    <div class="interaction-ui-upperRight">

        <div class="icon-part" @click="clickChat" v-show="userInfoRef.memberStatus === -1">
            <div class="icon-text">
                <font-awesome-icon icon="fa-solid fa-comments" />
            </div>
            <span class="icon-span" tkey="聊天">{{i18n.tkey("lang_chat_text")}}</span>
        </div>

        <div class="icon-part" @click="clickLogin" v-show="userInfoRef.memberStatus === 0">
            <div class="icon-text">
                <font-awesome-icon icon="fa-solid fa-mobile-screen-button" />
            </div>
            <span class="icon-span" tkey="登錄">{{i18n.tkey("lang_login")}}</span>
        </div>

        <div class="icon-part" @click="clickAccount" v-show="userInfoRef.memberStatus === -1">
            <div class="icon-text">
                <font-awesome-icon icon="fa-solid fa-mobile-screen-button" />
            </div>
            <span class="icon-span" tkey="我的手機">{{i18n.tkey("lang_my_phone")}}</span>
        </div>
    </div>
</template>

<script setup>

//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCommentDots, faComments, faChevronRight, faAddressCard, faStore, faXmark, faDollarSign, faCircleH, faMobileScreenButton, faHelicopter, faCircleInfo, faArrowRightFromBracket, faMagnifyingGlass, faVolumeHigh, faVolumeXmark, faBroom, faUserAstronaut, faElevator, faRectangleList, faLanguage, faFileInvoiceDollar, faLeftRight } from '@fortawesome/free-solid-svg-icons'
import {inject, toRef} from "vue";
import {useUserinfo} from "@/stores/userinfo";

library.add(faCommentDots, faComments, faChevronRight, faAddressCard, faStore, faXmark, faDollarSign, faCircleH, faMobileScreenButton, faHelicopter, faCircleInfo, faArrowRightFromBracket, faMagnifyingGlass, faVolumeHigh, faVolumeXmark, faBroom, faUserAstronaut, faElevator, faRectangleList, faLanguage, faFileInvoiceDollar, faLeftRight)

const props = defineProps([])
const emits = defineEmits(["goLogin", "goAccount", "goChat"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

function clickLogin(){
    emits("goLogin")
}

function clickAccount(){
    emits("goAccount")
}

function clickChat(){
    emits("goChat")
}

</script>

<style scoped>
@media screen and (min-width: 520px) {
    .interaction-ui-upperRight {
        position: absolute;
        top: 20px;
        width: 100%;
        /*padding-right: 20px;*/
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: center;
        box-sizing: border-box;
        font-size: 12px;
        user-select: none;

    }
}

@media screen and (max-width: 520px) {
    .interaction-ui-upperRight {
        position: absolute;
        top: 20px;
        right: 10px;
        width: 40px;
        /*padding-right: 20px;*/
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: center;
        box-sizing: border-box;
        font-size: 12px;
        user-select: none;
        flex-wrap: wrap;
    }
}

@media screen and (min-width: 520px) {
    /*.interaction-ui-upperRight .icon-part {*/
    /*    width: 60px;*/
    /*    height: 60px;*/
    /*    background: #ffffff;*/
    /*    border-radius: 50%;*/
    /*    border: #2c3e50;*/
    /*    margin-right: 20px;*/
    /*}*/

    /*.interaction-ui-upperRight .icon-part .icon-text {*/
    /*    margin-top: 10px;*/
    /*    font-size: 20px;*/
    /*    pointer-events: none;*/
    /*}*/

    /*.interaction-ui-upperRight .icon-part .icon-span {*/
    /*    pointer-events: none;*/
    /*}*/

    .interaction-ui-upperRight .icon-part {
        width: 40px;
        height: 40px;
        background: #ffffff;
        border-radius: 50%;
        border: #2c3e50;
        margin-right: 10px;
        /*margin-bottom: 10px;*/
    }

    .interaction-ui-upperRight .icon-part .icon-text {
        margin-top: 10px;
        font-size: 20px;
        pointer-events: none;
    }

    .interaction-ui-upperRight .icon-part .icon-span {
        display: none;
        pointer-events: none;
    }
}

@media screen and (max-width: 520px) {
    .interaction-ui-upperRight .icon-part {
        width: 40px;
        height: 40px;
        background: #ffffff;
        border-radius: 50%;
        border: #2c3e50;
        /*margin-right: 20px;*/
        margin-bottom: 10px;
    }

    .interaction-ui-upperRight .icon-part .icon-text {
        margin-top: 10px;
        font-size: 20px;
        pointer-events: none;
    }

    .interaction-ui-upperRight .icon-part .icon-span {
        display: none;
        pointer-events: none;
    }
}
</style>